export default __webpack_public_path__ + "static/media/ecologistic-big.69f47689.png";